import React from 'react'
import { useNavigate } from 'react-router-dom-v5-compat'

import Navigator, { TNavigatorItem } from '@/app/component/atom/navigator'
import SidebarLayout from '@/app/component/layout/sidebar-layout'
import { OrgReportFunction } from '@/app/module/reports/types'

import CallRecordingsContainer from './call-recordings.container'
import CampaignReportListContainer from './campaign-report-list.container'
import SMSReportContainer from './sms-report.container'
import SpendReportContainer from './spend-report.container'

type Props = {
  isCreateMode?: boolean
  reportType: OrgReportFunction
}

const navigatorItems: TNavigatorItem<OrgReportFunction>[] = [
  {
    icon: 'campaign',
    label: 'Campaign Reports',
    path: OrgReportFunction.Campaign,
  },
  {
    icon: 'money_off',
    label: 'Spend Reports',
    path: OrgReportFunction.Spend,
  },
  {
    icon: 'analytics',
    label: 'Deliverability Reports',
    path: OrgReportFunction.Deliverability,
  },
  {
    icon: 'call',
    label: 'Call Recordings',
    path: OrgReportFunction.Recordings,
  },
]

const ReportsContainer: React.FC<Props> = ({ isCreateMode = false, reportType }) => {
  const navigate = useNavigate()

  const handleItemClick = React.useCallback(
    (path: OrgReportFunction) => {
      // Don't navigate if the clicked path is already active to avoid pushing the same path to history
      if (path === reportType) {
        return
      }

      navigate(`/reports/${path}`)
    },
    [reportType, navigate],
  )

  const sidebar = (
    <Navigator
      activePath={reportType}
      id="reports"
      items={navigatorItems}
      title="Reports"
      onItemClick={handleItemClick}
    />
  )

  const content = (
    <>
      {reportType === OrgReportFunction.Campaign && <CampaignReportListContainer />}
      {reportType === OrgReportFunction.Spend && <SpendReportContainer isCreateMode={isCreateMode} />}
      {reportType === OrgReportFunction.Deliverability && <SMSReportContainer isCreateMode={isCreateMode} />}
      {reportType === OrgReportFunction.Recordings && <CallRecordingsContainer />}
    </>
  )

  return <SidebarLayout sidebar={sidebar} content={content} />
}

export default ReportsContainer
